import React, { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelect, useSelectWithParams } from '../../../../../../../utils/selector.utils';
import { KpiHeaderSession } from './KpiHeaderSession';
import { ISession } from '../../../../../../../app/resource/session/session.types';
import { IMeeting } from '../../../../../../../app/resource/meeting/meeting.types';
import { kpiSelectors } from '../../../../../../../app/resource/kpi/kpi.selectors';
import { IKpi } from '../../../../../../../app/resource/kpi/kpi.types';
import { sessionsPageSelectors } from '../../../../../../../app/page/page-storage/sessions/sessions.selectors';

export const WidgetKpiHeader: FunctionComponent<{ meetingId: IMeeting['id'] }> = ({ meetingId }) => {
  const { sessionId: currentSessionId } = useParams<{
    sessionId: ISession['id'];
  }>();
  let scrollTargetSessionId = currentSessionId;

  const nextSessionId = useSelect(sessionsPageSelectors.selectNextSessionId);

  if (!currentSessionId && nextSessionId) {
    scrollTargetSessionId = nextSessionId;
  }
  const kpi = useSelectWithParams(kpiSelectors.selectResourceById, meetingId) as IKpi;

  const [sessionIds, setSessionIds] = useState<ISession['id'][]>([]);

  useEffect(() => {
    if (kpi) {
      setSessionIds(kpi.sessionIds);
    }
  }, [kpi]);

  return (
    <div className="flex-table header panel mb-1 aic py-0" role="rowgroup">
      <div className="flex-row first" role="columnheader">
        <span className="kpi-header-user">USER</span>
        <span className="kpi-header-measurable">MEASURABLE</span>
        <span className="kpi-header-goal">GOAL</span>
      </div>
      <div className="flex-row" role="columnheader">
        <div className="panel single-line w-auto" style={currentSessionId ? { height: 54 } : {}}>
          {sessionIds.map((sessionId: ISession['id']) => (
            <KpiHeaderSession
              key={sessionId}
              sessionId={sessionId}
              active={sessionId === currentSessionId}
              isScrollTarget={scrollTargetSessionId === sessionId}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
